import type { APIInstance } from "./apiService";

export interface Analyst {
  user_id: string;
  name: string;
  role_id: number;
  role_name: string;
}

export interface UserTemplateResponse {
  template_id: string | null;
}

export class UsersService {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  async getAnalysts(firmId: string, allowSuperAnalyst: boolean = true): Promise<Analyst[]> {
    const response = await this.api.get<Analyst[]>(`/firms/${firmId}/users/analysts`, {
      params: {
        allow_super_analyst: allowSuperAnalyst,
      },
    });
    return response.data;
  }

  async getPhysicianTemplate(physicianId: string): Promise<UserTemplateResponse> {
    const response = await this.api.get<UserTemplateResponse>(`/users/${physicianId}/template`);
    return response.data;
  }

  async deleteFirmUser(firmId: string, userId: string): Promise<void> {
    await this.api.delete(`/firms/${firmId}/users/${userId}`);
  }
}
